import { Component } from '@angular/core';

import {AlertController, Events, LoadingController, NavController, Refresher} from 'ionic-angular';
import { ModalController, ViewController, ToastController } from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";

import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { PopoverController } from 'ionic-angular';
import { NotificationsPopover } from './popover';
import * as moment from 'moment';
import * as _ from "lodash";


@Component({
    selector: 'page-notifications',
    templateUrl: 'notifications.html'
})
export class NotificationsPage {
    notifications: any;
    notifications_unread: any = 0;
    notificationsRef: any;
    sessionRef: any;
    userRef: any;

    inited: any = false;
    loading: any = false;
    order: any = false;
    currently_loading: any = false;

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public popoverCtrl: PopoverController,
        public events: Events,
        public loadingCtrl: LoadingController
    ) {
        moment.locale('fr');
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state && !this.currently_loading)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading && this.currently_loading){
            //this.loadingCtrl.dismiss();
            this.loading.dismiss();
            this.currently_loading = false;
        }
    }
    presentPopover(event: Event) {
        let popover = this.popoverCtrl.create(NotificationsPopover);
        var that = this;
        popover.onDidDismiss(data => {
            if(data == 'readall')
            {
                that.notifications.forEach(notification => {
                   if(!notification.read)
                   {
                       this.userData.setNotificationAsRead(notification);
                   }
                });

            }
        });
        popover.present({ ev: event });
    }
    ionViewDidEnter() {

        this.getUserInfos();
    }
    ionViewWillUnload() {

        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }
    getUserInfos()
    {
        var that = this;
        if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(user => {
                if(!that.userRef || that.userRef.closed) {
                    that.userRef = that.userData.load().subscribe(user => {

                        that.notifications = that.userData.get('notifications/list');
                        that.notifications_unread = that.userData.get('notifications/unread');
                    });
                }
            });
        }
    }
    listenToLoginEvents() {
        this.events.subscribe('user:logout', () => {
            
            //this.sessionRef.unsubscribe();
            //this.userRef.unsubscribe();
        });
    }
    doRefresh(refresher: Refresher) {
        this.notifications = this.userData.get('notifications/list');
        this.notifications_unread = this.userData.get('notifications/unread');
        setTimeout(() => {
            refresher.complete();

            const toast = this.toastCtrl.create({
                message: 'Les notifications ont été mises à jour.',
                duration: 3000
            });
            toast.present();
        }, 1000);

    }
    setRead(notification) {
        this.userData.setNotificationAsRead(notification);

        //this.nav.push(notification.page,notification.page_arguments)
    }
    followNotification(event,notification) {

        event.stopPropagation();
        if(notification.buttons && notification.buttons.length>0)
        {
            this.followNotificationLink(event,notification,notification.buttons[0].page,notification.buttons[0].page_arguments);
        }
        else {
            this.userData.setNotificationAsRead(notification);
            this.nav.push(notification.page, notification.page_arguments)
        }
    }
    followNotificationLink(event,notification,page,args) {
        event.stopPropagation();
        this.userData.setNotificationAsRead(notification);

        this.nav.push(page,args)
    }
    formatDate(date)
    {


        var format = moment(date,"DD/MM/YYYY HH:mm");
        var string =  format.fromNow();

        return string[0].toUpperCase() + string.substring(1);
    }

    swipe(event)
    {
        if(event.direction === 2) {
            this.nav.parent.select(1);
        }
        /*if(event.direction === 4) {
            this.nav.parent.select(0);
        }*/
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/notifications/notifications.ts